import { lazy, Suspense } from 'react';

import { useRouteMatch } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { usePrimaryCategoryConfigDetailPage } from '@webapp/platform/organization-management/pages/hooks/usePrimaryCategoryConfigDetailPage'
import messages from '@webapp/platform/organization-management/pages/messages'
import { type PrimaryCategoryConfigDetailPageParams } from './types'

const PrimaryCategoryConfigDetailViewChunk = lazy(() =>
  import('../feature-sets/PrimaryCategoryConfigDetailView').then(
    ({ PrimaryCategoryConfigDetailView }) => ({
      default: PrimaryCategoryConfigDetailView,
    })
  )
)

export const PrimaryCategoryConfigDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const match = useRouteMatch<PrimaryCategoryConfigDetailPageParams>()

  const {
    data: { config },
  } = usePrimaryCategoryConfigDetailPage({
    primaryCategoryId: Number(match.params.id),
  })

  return (
    <Page
      pageTitle={`${intl.formatMessage(messages.managePrimaryCategoriesTitle)}`}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('PrimaryCategoryConfigListPage', { tab: 'active' }),
          name: intl.formatMessage(messages.managePrimaryCategoriesTitle),
        },
        {
          name: config?.name ? config.name : '',
          escapeCaseFormatting: true,
        },
      ]}
    >
      <Suspense fallback={null}>
        <PrimaryCategoryConfigDetailViewChunk />
      </Suspense>
    </Page>
  );
}
